<template>
  <page
    :back-to="getPreviousUrl"
    :title="'Publisher - #' + $route.params.id"
    :loading="publisher === null"
    size="is-desktop"
  >
    <div slot="page-header-right">
      <router-link
        :to="'/publishers/' + $route.params.id + '/edit'"
        class="button"
      >
        <span>Edit</span>
      </router-link>
    </div>

    <div v-if="publisher">
      <div class="box">
        <div class="level">
          <div class="level-left">
            <div class="media" style="align-items: center;">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img
                    v-if="publisher.photo"
                    :src="publisher.photo.md"
                    :alt="publisher.name"
                    class="is-circle"
                    style="width: 64px; height: 64px;"
                  />
                </p>
              </figure>
              <div>
                <div class="title is-5">{{ publisher.name }}</div>

                <div>
                  <span class="tag">{{ publisher.type }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="tabs is-marginless">
          <ul>
            <router-link tag="li" :to="`/publishers/${publisher.id}`">
              <a>General Info</a>
            </router-link>

            <router-link tag="li" :to="`/publishers/${publisher.id}/managers`">
              <a>Managers</a>
            </router-link>
          </ul>
        </div>

        <div class="card-content is-paddingless">
          <router-view :publisher="publisher"></router-view>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      publisher: null
    };
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    }
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/publishers/" + this.$route.params.id)
        .then(response => {
          this.publisher = response.data.data;
        });
    }
  }
};
</script>
